const comments = [
  {
    name: '小漫迷Lucy',
    avatar: 'L',
    color: 'accent',
    text: '韩漫屋真的太良心了！不用注册就能直接看，画质也超级清晰。追了好几部恋爱韩漫，更新速度和韩国那边几乎同步，强烈推荐给所有韩漫爱好者！',
    tag: '忠实读者 · 使用半年',
  },
  {
    name: '追更达人阿杰',
    avatar: 'J',
    color: 'primary',
    text: '之前试过很多漫画网站，韩漫屋的下拉式阅读体验是最好的，完美适配手机竖屏。而且全章节免费看这点真的没话说，终于不用到处找解锁方法了。',
    tag: '活跃用户 · 每日阅读',
  },
  {
    name: '漫画控小雨',
    avatar: 'Y',
    color: 'secondary',
    text: '作为一个重度韩漫迷，韩漫屋的分类真的很细致，从古风到都市再到奇幻，找漫画超方便。推荐给身边所有朋友了，免费韩漫大全不是吹的！',
    tag: '韩漫老粉 · 推荐达人',
  },
];

const colorMap: Record<string, { bg: string; text: string; badge: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-600', badge: 'bg-primary-100 text-primary-700' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-600', badge: 'bg-accent-100 text-accent-700' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-600', badge: 'bg-secondary-100 text-secondary-700' },
};

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            读者之声
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            听听韩漫屋的读者们怎么说，真实用户评价，见证我们的品质
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="p-6 md:p-7 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <span
                  className={`w-10 h-10 rounded-full ${colorMap[comment.color].bg} ${colorMap[comment.color].text} flex items-center justify-center font-semibold text-sm`}
                >
                  {comment.avatar}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                  <span className={`inline-block text-xs px-2 py-0.5 rounded-full ${colorMap[comment.color].badge} mt-0.5`}>
                    {comment.tag}
                  </span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{comment.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}